import React from 'react';
import '../../../css/Form.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
// import ImagesPopup from '../../../helper/ImagesPopup';
import UploadFile from '../../../helper/UploadFile';
import { useRef } from 'react';
import Utils from '../../../helper/Utils';

const ProfessionalDetails = (props) => {

	// used States:
	const {
		onChangeHandler,
		userDetails,
		setUserDetails,
		experiences,
		ProfesionalSelectHandler,
		functionalAreas,
		ProfessionalDetailsHandler,
		addComponent,
		professionalDetails,
		setProfessionalDetails,
		handleRenderComp,
		addMaxValue,
		addEnteredValue,
		saveDraft,
		DateChangeHandler,
		ProfessionalDetailsDropDownHandler,
		ValidationError,
		topFunction,
		scrollToBottom,
		requiredFields,
		GenerateRemovePopup,
		employmentType,
		// onFileChange,
		// imageRemoveHandler,
		// openImageInTab,
		checkDecimal,
		// dashboardHandler,
		// LockDashboard,
		scrollHandler,
		UploadData,
		setSaveTheData
	} = props;
	// const [openView, setOpenView] = useState({
	// 	popupOpen: false,
	// 	currentIndex: null,
	// 	ExpType: ''
	// });

	// const popupHandler = (event) => {
	// 	var oldObj = { ...openView };
	// 	oldObj.popupOpen = true;
	// 	oldObj.currentIndex = event.target.id;
	// 	oldObj.ExpType = event.target.name;
	// 	setOpenView(oldObj);
	// };

	// const ClosePopup = () => {
	// 	var oldObj = { ...openView };
	// 	oldObj.popupOpen = false;
	// 	setOpenView(oldObj);
	// };

	//UPLOAD COMPONENT DATA SETTING
	const uploadProcessCode = "EMPLOYEE_APP_PROFESSIONAL_EXP";
	const processCodeData = UploadData.filter((item) => item.uploadProcessCode === uploadProcessCode)


	const getUploadData = (data, params) => {
		let newState = params === "current" ? { ...userDetails } : [...professionalDetails];
		if (params === "current") {
			newState.CurrentExpDocuments = data
			setUserDetails(newState);
		} else {
			newState[params].experienceDocumentList = data
			setProfessionalDetails(newState);
		}
		setSaveTheData(true)
	};


	return (
		<div className="appForm" id='APP-FORM' onScroll={scrollHandler}
			style={{ height: window.innerWidth > 800 ? window.innerHeight - 240 : window.innerWidth <= 375 ? window.innerHeight - 275 : window.innerWidth <= 425 ? window.innerHeight - 260 : window.innerHeight - 260, overflowY: "auto" }}>
			<div className="animated zoomIn container-fluid">
				<div className="row">
					<div className="col-md-6 col-sm-6">
						{/* <button
							className={LockDashboard ? 'disabledDashboardBtn' : 'backtoDashboardBtn'}
							onClick={dashboardHandler}
							disabled={LockDashboard}
						>
							<i className="fa fa-arrow-left backIcon" />Back to dashboard
						</button> */}
					</div>
					<div className="col-md-6 col-sm-6">
						<p className="requiredHeader ">
							<span className="requiredTextHeading">*</span> These fields are required
						</p>
					</div>
				</div>
				<div className="formWrapper">
					<div className="row">
						<div className="col-md-12 col-xs-12">
							<h4 className="professionalHeader ">
								Professional Experience
							</h4>
						</div>
						<div className="col-md-12" style={{ paddingLeft: '8px' }}>
							<div className="col-sm-4 col-xs-12" style={{ display: 'inline-block' }}>
								<label className="formExpLabel ">
									Currently Working
								</label>
								<span className="requiredText" style={{ top: '7px' }}>*</span>
							</div>
							<div className="col-sm-5 col-xs-12" style={{ display: 'inline-block', bottom: '15px' }}>
								<label className="radio-inline">
									<input
										className="space"
										onChange={onChangeHandler}
										type="radio"
										name="currentWorking"
										value="Yes"
										checked={userDetails.currentWorking === 'Yes'}
									/>
									Yes
								</label>
								<label className="radio-inline">
									<input
										className="space"
										onChange={onChangeHandler}
										type="radio"
										name="currentWorking"
										value="No"
										checked={userDetails.currentWorking === 'No'}
									/>
									No
								</label>
							</div>
							<div className="col-12 text-center" style={{ display: 'inline-block', bottom: '15px' }}>
								{requiredFields.commonErrors[0].currentWorkingReqError ? (
									<p className="ValidationError">
										<i className="fa fa-warning warningIcon" />
										Currently Working cannot be empty
									</p>
								) : null}
							</div>
						</div>
					</div>
				</div >
				<div className="appDivider" />
				{
					userDetails.currentWorking === 'Yes' ?
						<h5>
							Current Experience
						</h5> : null
				}

				{
					userDetails.currentWorking === 'Yes' ? (
						<div>
							<div className='container'>
								<div className="row animated zoomIn">
									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											Experience Type
										</label>
										<span className="requiredText">*</span>
										<Select
											className="z-depth-3"
											value={userDetails.currentExperienceType}
											onChange={(selected) =>
												ProfesionalSelectHandler(selected, 'currentExperienceType')}
											options={experiences}

										/>
										{requiredFields.commonErrors[0].currentExperienceTypeReqError ? (
											<p className="ValidationError">
												<i className="fa fa-warning warningIcon" />
												Experience cannot be empty
											</p>
										) : null}
									</div>

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											Functional Area
										</label>
										<span className="requiredText">*</span>
										<Select
											className="z-depth-3"
											isDisabled={
												userDetails.currentExperienceType === '' && functionalAreas.length === 0 ? (
													true
												) : (
													false
												)
											}
											value={userDetails.currentFunctionalArea}
											onChange={(selected) =>
												ProfesionalSelectHandler(selected, 'currentFunctionalArea')}
											options={functionalAreas.CurrentFunctional}
										/>
										{requiredFields.commonErrors[0].currentFunctionalAreaReqError ? (
											<p className="ValidationError">
												<i className="fa fa-warning warningIcon" />
												Functional area cannot be empty
											</p>
										) : null}
									</div>

									{userDetails.currentFunctionalArea !== null ? userDetails.currentFunctionalArea
										.label === ('Others' || 'others') ? (
										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												Other
											</label>
											<span className="requiredText">*</span>
											<input
												className="form-control z-depth-3"
												value={userDetails.currentOtherFunctionalArea}
												onChange={onChangeHandler}
												type="text"
												name="currentOtherFunctionalArea"
												maxLength="100"
											/>
											{requiredFields.commonErrors[0].currentOtherFunctionalAreaReqError ? (
												<p className="ValidationError">
													<i className="fa fa-warning warningIcon" />
													This cannot be empty
												</p>
											) : null}
										</div>
									) : null : null
									}

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											Employment Type
										</label>
										<span className="requiredText">*</span>
										<Select
											className="z-depth-3"
											value={userDetails.currentEmpType}
											onChange={(selected) => ProfesionalSelectHandler(selected, 'currentEmpType')}
											options={employmentType}
										/>
										{
											requiredFields.commonErrors[0].currentEmpTypeReqError ? (
												<p className="ValidationError">
													<i className="fa fa-warning warningIcon" />
													Employment cannot be empty
												</p>
											) : null
										}
									</div >

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											Designation
										</label>
										<span className="requiredText">*</span>
										<input
											className="form-control z-depth-3"
											value={userDetails.currentDesignation}
											type="text"
											name="currentDesignation"
											onChange={onChangeHandler}
											maxLength="30"
										/>
										{
											requiredFields.commonErrors[0].currentDesignationReqError ? (
												<p className="ValidationError">
													<i className="fa fa-warning warningIcon" />
													Designation cannot be empty
												</p>
											) : null
										}
									</div >

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											From Date
										</label>
										<span className="requiredText">*</span>
										<DatePicker
											onChange={(date) =>
												DateChangeHandler(date, 'currentFromDate', '', 'currentExp')}
											selected={userDetails.currentFromDate}
											showMonthDropdown
											showYearDropdown
											dateFormat="dd-MMM-yyyy"
											className="form-control z-depth-3"
											dropdownMode="select"
											autoComplete="off"
											placeholderText="dd-mmm-yyyy"
											maxDate={new Date()}
											disabled={userDetails.currentEmpType !== '' ? false : true}
										/>
										{
											requiredFields.commonErrors[0].currentFromDateReqError ? (
												<p className="ValidationError">
													<i className="fa fa-warning warningIcon" />
													From Date cannot be empty
												</p>
											) : null
										}
									</div >

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											To Date
										</label>
										<span className="requiredText">*</span>
										<DatePicker
											selected={userDetails.currentToDate}
											showMonthDropdown
											showYearDropdown
											dateFormat="dd-MMM-yyyy"
											className="form-control z-depth-3"
											dropdownMode="select"
											autoComplete="off"
											placeholderText="dd-mmm-yyyy"
											minDate={userDetails.currentFromDate}
											readOnly
										/>
									</div >

									<div className="col-md-4 col-lg-3 col-sm-6 ">
										<label className="formRenderlabel ">
											Years
										</label>
										<input
											className="form-control z-depth-3"
											value={userDetails.currentTotalYears}
											type="text"
											name="currentTotalYears"
											readOnly
										/>
									</div >

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											Months
										</label>
										<input
											className="form-control z-depth-3"
											value={userDetails.currentTotalMonths}
											type="text"
											name="currentTotalMonths"
											readOnly
										/>
									</div >

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											Notice Period(Months)
										</label>
										<span className="requiredText">*</span>
										<input
											className="form-control z-depth-3"
											value={userDetails.currentNoticePeriod}
											type="text"
											name="currentNoticePeriod"
											onChange={onChangeHandler}
											maxLength="100"
										/>
										{
											requiredFields.commonErrors[0].currentNoticePeriodReqError ? (
												<p className="ValidationError">
													<i className="fa fa-warning warningIcon" />
													Notice period cannot be empty
												</p>
											) : null
										}
									</div >

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											Current Salary (INR)
										</label>
										{/* <span className="requiredText">*</span> */}
										<input
											className="form-control z-depth-3"
											value={userDetails.currentSalary}
											placeholder='Per Month'
											type="text"
											name="currentSalary"
											onChange={onChangeHandler}
											maxLength="100"
											onBlur={checkDecimal}
										/>
										{
											ValidationError.currentSalaryError ? (
												<p className="ValidationError">
													<i className="fa fa-warning warningIcon" />
													Please enter a valid number
												</p>
											) : null
										}
										{/* {
											requiredFields.commonErrors[0].currentSalaryReqError ? (
												<p className="ValidationError">
													<i className="fa fa-warning warningIcon" />
													Salary cannot be empty
												</p>
											) : null
										} */}
									</div>

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">

											Institution
										</label>
										<span className="requiredText">*</span>
										<input
											className="form-control z-depth-3"
											value={userDetails.currentInstitute}
											type="text"
											name="currentInstitute"
											onChange={onChangeHandler}
											maxLength="100"
										/>
										{
											requiredFields.commonErrors[0].currentInstituteReqError ? (
												<p className="ValidationError">
													<i className="fa fa-warning warningIcon" />
													Institution cannot be empty
												</p>
											) : null
										}
									</div>

									<div className="col-md-4 col-lg-3 col-sm-6">
										<label className="formRenderlabel ">
											Document
											<span className='upload-accepted-format-indication'>({processCodeData[0]?.fileTypeList.join(',')})</span>
										</label>
										<UploadFile
											callback={getUploadData}
											data={userDetails?.CurrentExpDocuments}
											isMulti
											keyList={processCodeData}
											id={uploadProcessCode}
											otherParams={"current"}
										/>
										<br />
										<span className='upload-accepted-format-indication'>File size limit: less than 1024kb</span>
										{/* <label className="educationUpload">
											<input
												type="file"
												style={{ display: 'none' }}
												onChange={(event) => onFileChange(event, 'CurrentExpDocuments')}
												// accept="image/*"
												id="0"
												multiple
											/>
											[ <i className="fa fa-upload uploadIcon" aria-hidden="true" /> Upload ]
										</label>
										<label className="educationUpload">
											<input
												type="button"
												style={{ display: 'none' }}
												onClick={popupHandler}
												id="0"
												name="current"
											/>{' '}
											[ <i className="fa fa-eye uploadIcon" aria-hidden="true" /> view ]
										</label> */}
									</div >
								</div >
							</div >
							<div className="appDivider" />
						</div >
					) : null}
				{userDetails.currentWorking === 'Yes' ? (<h5>
					Other Experiences
				</h5>) : ""}


				<div className="formWrapper">
					{professionalDetails.map((el, index) => {
						return (
							<div key={index}>
								<div>
									<div className="row animated zoomIn">
										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												Experience Type
											</label>
											<Select
												className="z-depth-3"
												value={el.ExperienceType}
												onChange={(selected) =>
													ProfessionalDetailsDropDownHandler(
														selected,
														'ExperienceType',
														index
													)}
												options={experiences}
												autoFocus={professionalDetails?.length - 1}
												isClearable
											/>
										</div>

										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												Functional Area
											</label>
											<Select
												className="z-depth-3"
												isDisabled={
													functionalAreas.length === 0 && el.ExperienceType === '' ? (
														true
													) : (
														false
													)
												}
												value={el.functionalArea}
												onChange={(selected) =>
													ProfessionalDetailsDropDownHandler(
														selected,
														'functionalArea',
														index
													)}
												options={functionalAreas.PreviousFunctional[index]}
												isClearable
											/>
										</div>
										{el.functionalArea !== null ? el.functionalArea.label ===
											('Others' || 'others') ? (
											<div className="col-md-4 col-lg-3 col-sm-6">
												<label className="formRenderlabel ">
													Other
												</label>
												<span className="requiredText">*</span>
												<input
													className={
														requiredFields.profReq[index].otherFunctAreaReqError ? (
															'form-control invalid z-depth-3'
														) : (
															'form-control z-depth-3'
														)
													}
													value={el.OtherFunctionalArea}
													onChange={ProfessionalDetailsHandler}
													type="text"
													name="OtherFunctionalArea"
													id={index + 'OtherFunctionalArea'}
													maxLength="100"
												/>
												{requiredFields.profReq[index].otherFunctAreaReqError ? (
													<p className="ValidationError">
														<i className="fa fa-warning warningIcon" />
														This cannot be empty
													</p>
												) : null}
											</div>
										) : null : null}

										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												Employment Type
												{/* <span className="requiredText"> * </span> */}
											</label>
											<Select
												className="z-depth-3"
												value={el.EmpType}
												onChange={(selected) =>
													ProfessionalDetailsDropDownHandler(selected, 'EmpType', index)}
												options={employmentType}
											// isClearable
											/>
										</div>

										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												Designation
											</label>
											<input
												className="form-control z-depth-3"
												value={el.designation}
												type="text"
												name="designation"
												id={index + 'designation'}
												onChange={ProfessionalDetailsHandler}
												maxLength="30"
											/>
										</div >

										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												From Date
											</label>
											<DatePicker
												onChange={(date) =>
													DateChangeHandler(date, 'fromDate', index, 'Professional')}
												selected={el.fromDate}
												showMonthDropdown
												showYearDropdown
												dateFormat="dd-MMM-yyyy"
												className="form-control z-depth-3"
												dropdownMode="select"
												autoComplete="off"
												placeholderText="dd-mmm-yyyy"
												maxDate={el.ToDate || new Date()}
												// disabled={Utils.isNullorWhiteSpace(el?.EmpType)}
												isClearable
												onFocus={e => e.target.blur()}
											/>
										</div >

										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												To Date
											</label>
											<DatePicker
												onChange={(date) =>
													DateChangeHandler(date, 'ToDate', index, 'Professional')}
												selected={el.ToDate}
												showMonthDropdown
												showYearDropdown
												dateFormat="dd-MMM-yyyy"
												className="form-control z-depth-3"
												dropdownMode="select"
												autoComplete="off"
												placeholderText="dd-mmm-yyyy"
												minDate={el.fromDate}
												isClearable
												onFocus={e => e.target.blur()}
												maxDate={new Date()}
											/>
										</div >

										<div className="col-md-4 col-lg-3 col-sm-6 ">
											<label className="formRenderlabel ">
												Years
											</label>
											<input
												className="form-control z-depth-3"
												value={el.TotalYears}
												type="text"
												name="years"
												id={index + 'years'}
												readOnly
											/>
										</div >

										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												Months
											</label>
											<input
												className="form-control z-depth-3"
												value={el.TotalMonths}
												type="text"
												name="months"
												id={index + 'months'}
												readOnly
											/>
										</div >

										<div className="col-md-4 col-lg-3 col-sm-6">
											<label className="formRenderlabel ">
												Institution
											</label>
											<input
												className="form-control z-depth-3"
												value={el.institution}
												type="text"
												name="institution"
												id={index + 'institution'}
												onChange={ProfessionalDetailsHandler}
												maxLength="100"
											/>
										</div >

										<div className="col-md-3">
											<label className="formRenderlabel ">
												Document
												<span className='upload-accepted-format-indication'>({processCodeData[0]?.fileTypeList.join(',')})</span>
											</label>

											<UploadFile
												callback={getUploadData}
												data={el?.experienceDocumentList}
												isMulti
												keyList={processCodeData}
												id={uploadProcessCode}
												otherParams={index}
											/> <br />
											<span className='upload-accepted-format-indication'>File size limit: less than 1024kb</span>
											{/* <label className="educationUpload">
												<input
													type="file"
													style={{ display: 'none' }}
													onChange={(event) => onFileChange(event, 'PrevExpDocuments')}
													// accept="image/*"
													id={index}
													multiple
												/>
												[ <i className="fa fa-upload uploadIcon" aria-hidden="true" /> Upload ]
											</label> */}

											{/* <label className="educationUpload">
												<input
													type="button"
													style={{ display: 'none' }}
													onClick={popupHandler}
													id={index}
													name="previous"
												/>{' '}
												[ <i className="fa fa-eye uploadIcon" aria-hidden="true" /> view ]
											</label> */}
										</div >
										{index >= 1 ? (
											<div
												className={
													el.functionalArea !== null ? el.functionalArea.label ===
														('Others' || 'others') ? (
														'col-md-3'
													) : (
														'col-md-6'
													) : (
														'col-md-6'
													)
												}
											>
												<button
													type="button"
													className="RemoveLinkButton pull-right"
													onClick={() =>
														GenerateRemovePopup(
															'Professional',
															index,
															'ProfessionalDetails',
															''
														)}
													id={index}
												>
													<i className="fa fa-trash RemoveIcon" />
													Remove
												</button>
											</div>
										) : null}
									</div >
								</div >
								<div className="appDivider" />
							</div >
						);
					})}
					<div className="row animated zoomIn">
						<div className="col-md-12">
							<button
								type="button"
								className="formLinkButton pull-right"
								onClick={() => addComponent('ProfessionalDetails')}
								tabIndex={0}
							>
								<span className="fa fa-plus formAddIcon" />
								Add More
							</button>
						</div>
					</div>
					<div className="appDivider" />
				</div >

				<div className="formWrapper" style={{ margin: "20px 8px" }}>
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="formExpLabel ">
								Total Full-time Experience
							</label>
						</div>
						<div className="col-md-2 col-xs-12">
							<input
								className="form-control z-depth-3"
								value={userDetails.TotalFullTimeYearsExp}
								type="text"
								name="TotalYears"
								readOnly
							/>
						</div>
						<div className="col-md-1 col-xs-12">
							<label className="formExpLabel ">
								Years
							</label>
						</div>
						<div className="col-md-2 col-xs-12">
							<input
								className="form-control z-depth-3"
								value={userDetails.TotalFullTimeMonthsExp}
								type="text"
								name="TotalMonths"
								readOnly
							/>
						</div>
						<div className="col-md-1 col-xs-12">
							<label className="formExpLabel ">
								Months
							</label>
						</div >
					</div >
				</div >

				<div className="formWrapper" style={{ margin: "20px 8px" }}>
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className="formExpLabel ">
								Total Part-time Experience
							</label>
						</div>
						<div className="col-md-2 col-xs-12">
							<input
								className="form-control z-depth-3"
								value={userDetails.TotalPartTimeYearsExp}
								type="text"
								name="TotalYears"
								readOnly
							/>
						</div>
						<div className="col-md-1 col-xs-12">
							<label className="formExpLabel ">
								Years
							</label>
						</div>
						<div className="col-md-2 col-xs-12">
							<input
								className="form-control z-depth-3"
								value={userDetails.TotalPartTimeMonthsExp}
								type="text"
								name="TotalMonths"
								readOnly
							/>
						</div>
						<div className="col-md-1 col-xs-12">
							<label className="formExpLabel ">
								Months
							</label>
						</div >
					</div >
				</div >
				<div className="formWrapper" style={{ margin: "20px 8px" }}>
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className=" ">
								Major Achievements
							</label>
						</div>
						<div className="col-md-7 col-xs-12">
							<textarea
								className="form-control z-depth-3"
								rows="7"
								name="majorAchievements"
								onChange={onChangeHandler}
								value={userDetails?.majorAchievements}
								maxLength="5000"

							/>
							<span
								className=""
								style={{ float: 'right', marginTop: '4px' }}
							>{`${addMaxValue - userDetails?.majorAchievements?.length} characters left`}</span>
						</div>
					</div>
				</div >

				<div className="formWrapper">
					<div className="row">
						<div className="col-md-3 col-xs-12">
							<label className=" " style={{ paddingTop: '0px', paddingBottom: '0px' }}>
								Expected Salary (Per Month) in INR
							</label>
							<span className="requiredText" style={{ top: "0px" }}>*</span>
						</div>
						<div className="col-md-5 col-xs-12" style={{ paddingTop: '2px' }}>
							<input
								className={
									ValidationError.expSalaryError ||
										requiredFields.commonErrors[0].expSalaryReqError ? (
										'form-control invalid z-depth-3'
									) : (
										'form-control z-depth-3'
									)
								}
								value={userDetails.expSalary}
								type="text"
								name="expSalary"
								onChange={onChangeHandler}
								onBlur={checkDecimal}
								maxLength="10"
							//id="expSalary"
							/>
							{ValidationError.expSalaryError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />
									Please enter a valid number
								</p>
							) : null}
							{requiredFields.commonErrors[0].expSalaryReqError ? (
								<p className="ValidationError">
									<i className="fa fa-warning warningIcon" />
									Expected salary cannot be empty
								</p>
							) : null}
						</div>
					</div>
				</div >
				<br />
				<div className="formWrapper">
					<div className="row">
						<div className="col-sm-4 parentDiv">
							<button
								className="PreviousButton z-depthButton"
								value="Previous"
								name="EducationDetails"
								onClick={() => handleRenderComp("EducationDetails")}
							>
								<i className="fas fa-chevron-left mr-3" style={{ color: "#ffffff" }}></i>
								Previous
							</button>
						</div>
						<div className="col-sm-4 parentDiv">
							<button
								className="saveDraftButton z-depthButton"
								value="Save Draft"
								name="saveDraft"
								onClick={saveDraft}
							>
								Save Draft
							</button>
						</div>
						<div className="col-sm-4 parentDiv">
							<button
								className="nextButton z-depthButton"
								value="Next"
								name="ResearchDetails"
								onClick={() => handleRenderComp("ResearchDetails")}
							>
								Next
								<i className="fas fa-chevron-right ml-4 mt-1" style={{ color: "#ffffff" }}></i>
							</button>
						</div>
					</div>
				</div>
				<button onClick={topFunction} id="myBtnUp">
					<div className="UpArrow" />
				</button>
				<button onClick={scrollToBottom} id="myBtnDown">
					<div className="downArrow" />
				</button>
			</div >
			{/* {
				openView.popupOpen ? (
					<ImagesPopup
						open={openView.popupOpen}
						close={ClosePopup}
						Imgdata={
							openView.ExpType === 'previous' ? (
								userDetails.PrevExpDocuments
							) : openView.ExpType === 'current' ? (
								userDetails.CurrentExpDocuments
							) : null
						}
						imageRemoveHandler={imageRemoveHandler}
						currentIndex={openView.currentIndex}
						compName={
							openView.ExpType === 'previous' ? (
								'PrevExpDocuments'
							) : openView.ExpType === 'current' ? (
								'CurrentExpDocuments'
							) : null
						}
						openImageInTab={openImageInTab}
						isFromEducation={false}
					/>
				) : null
			} */}
		</div >
	);
};

export default ProfessionalDetails;
